/**
 在线运维--订单列表；配置管理--设备快速查询--订单信息
 */
import React, { Component } from "react";
import PropsType from "prop-types";
import "../../../assets/stylus/com/display/process.styl";
import StubOrderInfo from "./stubOrderInfo";

class OrderInfoPage extends Component {
  constructor(props) {
    super(props);
    this.init();
    this.props = props;
    this.state = {
      currentPhase: "stub",
    };
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["stubInfoData"] = window.LayoutTab.tabParam.stubInfoData;
    }
  }

  componentDidMount() {
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      // console.log("entry:", window.LayoutTab, "tabParam:", window.LayoutTab.tabParam);
      this.query["stubInfoData"] = window.LayoutTab.tabParam.stubInfoData;
    }
    // console.log("componentDidMount stubInfoData:", this.query.stubInfoData);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div>
          <StubOrderInfo params={this.query.stubInfoData} onAdd={this.props.onAdd}></StubOrderInfo>
        </div>
      </div>
    );
    return Content;
  }
}

export default OrderInfoPage;

OrderInfoPage.propsType = {
  onAdd: PropsType.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/orderInfoPage.js